import { render } from "./ElectricityUsagePage.vue?vue&type=template&id=3b636ea5&scoped=true"
import script from "./ElectricityUsagePage.vue?vue&type=script&lang=js"
export * from "./ElectricityUsagePage.vue?vue&type=script&lang=js"

import "./ElectricityUsagePage.vue?vue&type=style&index=0&id=3b636ea5&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b636ea5"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QLayout,QDrawer,QScrollArea,QList,QItem,QItemSection,QIcon,QSeparator,QPageContainer,QPage,QCard,QCardSection});qInstall(script, 'directives', {Ripple});
